/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutShareSettingRequestBodyTypename = "PutShareSettingRequestBody" as const;

/**
 *
 * @export
 * @interface PutShareSettingRequestBody
 */
export interface PutShareSettingRequestBody {
  /**
   *
   * @type {boolean}
   * @memberof PutShareSettingRequestBody
   */
  enableShare?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PutShareSettingRequestBody
   */
  types?: Array<PutShareSettingRequestBodyTypesEnum>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutShareSettingRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PutShareSettingRequestBodyTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
}

export function PutShareSettingRequestBodyFromJSON(json: any): PutShareSettingRequestBody {
  return PutShareSettingRequestBodyFromJSONTyped(json, false);
}

export function PutShareSettingRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutShareSettingRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutShareSettingRequestBodyTypename,

    enableShare: !exists(json, "enable_share") ? undefined : json["enable_share"],
    types: !exists(json, "types") ? undefined : json["types"],
  };
}

export function PutShareSettingRequestBodyToJSON(object?: PutShareSettingRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    enable_share: value.enableShare,
    types: value.types,
  };
}
